import { XdmProviderApi } from "../lib/xdmProviderApi";

let service: XdmProviderApi = new XdmProviderApi("SmartSignals2");
